<div style="height: 100%;">
    <mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
        <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
            <mat-card-title>
                <div class="w-100 d-flex" style="background: #0f172a;">
                    <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">{{ "Application verouillée" | translate }}</span>
                    <button class="m-l-auto" mat-icon-button (click)="closeDialog()">
                        <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
                    </button>
                </div>
            </mat-card-title>
            <mat-card-subtitle style="background: #dee8ff;color: black;" class="p-t-16 p-b-16">
                <div class="d-flex">
                    <div class="d-flex flex">
                        <div style="border-right: 2px solid #1855d5; margin-right: 15px;">
                            <button mat-icon-button>
                                <i-tabler name="lock-square-rounded" class="icon-24 d-flex" style="color: #1cc8ff; align-items: center;"></i-tabler>
                            </button>
                        </div>
                        <div class="d-grid">
                            <span class="f-w-700"> {{ "Sélectionnez un compte" | translate }} </span>
                            <span style="padding-top: 8px; font-size: 13px; color: #9b9b9f; font-weight: 600;"> {{ "Application verouillée" | translate }}</span>
                        </div>
                    </div>
                    <div class="m-l-auto">
                    </div>
                </div>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content style="flex: 1; padding-top: 15px">
            <ng-container *ngFor="let account of usersAccounts">
                <mat-card class="cardWithShadow user-account" (click)="doSelectUserAccount(account)" [ngClass]="{'active': !!activeUserAccount && activeUserAccount.ID == account.ID }" style="margin-bottom: 15px !important;">
                    <mat-card-content>
                        <div class="d-flex align-items-center justify-content-start">
                            <img src="assets/images/profile/ninja-bo.png" class="rounded-circle" height="45px" />
                            <div class="m-l-16">
                            <h6 class="f-s-14 f-w-600 m-0">{{ account.USERNAME }}</h6>
                            <span class="f-s-14 d-block m-b-4">Utilisateur</span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </ng-container>
        </mat-card-content>
        <mat-card-actions class="d-block m-0 p-0" style="background-color: #ffffff; border-top: 3px solid #5d87ff;">
            <div class="d-flex w-100" style="padding-top: 6px;">
                <button type="button" mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;" (click)="closeDialog()">
                    {{ "ANNULER" | translate }}
                </button>
                <button mat-flat-button [disabled]="!activeUserAccount" (click)="onSubmit()" color="ccdark" style="font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;">
                    {{ "VALIDER" | translate }}
                </button>
            </div>
        </mat-card-actions>
    </mat-card>
</div>